module.exports = function getResource(label, vars = []) {
    const resources = {
        subscribeToFlash: 'Subscribe to Sephora FLASH and get Free shipping with no minimum for a full year.',
        eligibleForFreeFlash: 'You’re eligible for a FREE Sephora FLASH Subscription as a Rouge Tier Celebration Gift choice. Go to your',
        beautyInsiderPage: 'Beauty Insider page',
        toLearnMore: 'to learn more.',
        byClickingAddToBasket: 'By clicking “Add to Basket” you accept Sephora FLASH',
        termsAndConditions: 'terms and conditions',
        started: 'Started',
        ends: 'Ends',
        billedTo: 'Billed to',
        cancelAutoRenew: 'Cancel auto-renew',
        sephoraFlash: 'Sephora FLASH',
        learnMore: 'Learn more',
        cancelAutoRenewal: 'Cancel Sephora FLASH Auto Renewal',
        cancelAutoRenewalMessage: `<p>You can cancel your Sephora FLASH subscription auto renewal. Your card will not be charged on the renewal date.</p><p>You will still get free flash shipping with no minimum until the end of your current subscription, <b>${vars[0]}</b>.</p>`,
        cancelAutoRenewalMessageShort: `<p>Your Sephora FLASH subscription auto-renewal has been canceled.</p> <p>Your shipping benefits will end of <b>${vars[0]}</b>.</p>`,
        sephoraFlashTermsAndConditions: 'Sephora FLASH Terms & Conditions'
    };

    return resources[label];
};
